import {translate} from "../utils";

export default class SceneTitlePanel extends PIXI.Container {
    constructor(copy) {
        super();

        this._bg = new PIXI.NineSlicePlane(P3.assets.texture("title_bg"), 16, 16, 16, 16);
        this.addChild(this._bg);

        this._label = new PIXI.Text(copy, {
            dropShadow: true,
            dropShadowAngle: -4.3,
            dropShadowColor: 0xec008b,
            dropShadowDistance: 5,
            fill: "white",
            fontFamily: "Fred Fredburger",
            fontSize: 66,
            letterSpacing: 6,
            lineJoin: "round"
        });
        this._label.anchor.set(0.5);
        this._label.position.set(0, -5);
        this.addChild(this._label);

        this._bg.width = this._label.width + 60;
        this._bg.pivot.set(this._bg.width / 2, this._bg.height / 2);
    }
}